module.exports = __webpack_public_path__ + "assets/icons/ic_histogram_24px.svg";